import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spinner } from '../../components/ui/Spinner';
import { consumirRedirecionamento, lerRedirecionamento } from '../../lib/redirectPosLogin';
import { HomePage } from './HomePage';
import { HomePublicaPage } from './HomePublicaPage';

/**
 * Porta de entrada do portal (rota "/").
 * - Sem sessão: mostra a HOME PÚBLICA (transparência + serviços sem login, item 2.78).
 * - Logado sem perfil em `cidadaos` (1º acesso Google): manda completar cadastro.
 * - Logado: se houver destino pendente do login (ex.: serviço que o cidadão
 *   queria abrir antes de entrar pelo Google), retoma esse destino; senão painel.
 */
export function InicioGate() {
  const { session, cidadao, loading } = useAuth();
  const navigate = useNavigate();

  // Consome o destino pendente só depois que sessão + perfil estão prontos.
  useEffect(() => {
    if (loading || !session || !cidadao) return;
    const destino = consumirRedirecionamento();
    if (destino) navigate(destino, { replace: true });
  }, [loading, session, cidadao, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner tamanho="lg" />
      </div>
    );
  }

  if (!session) return <HomePublicaPage />;
  if (!cidadao) return <Navigate to="/completar-cadastro" replace />;

  // Há destino pendente: evita piscar o painel — o efeito acima vai navegar.
  if (lerRedirecionamento()) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner tamanho="lg" />
      </div>
    );
  }

  return <HomePage />;
}
